'use client'

import { usePathname,useRouter, useSearchParams } from 'next/navigation'
import { useCallback } from 'react'

export const useSearchState = (paramName: string, value: string) => {
	const router = useRouter()
	const searchParams = useSearchParams()
	const pathname = usePathname()

	const isActive = searchParams.get(paramName) === value

	const setState = useCallback(
		(active: boolean) => {
			const params = new URLSearchParams(searchParams)

			if (active) {
				params.set(paramName, value)
			} else {
				params.delete(paramName)
			}

			router.replace(`${pathname}${params.size ? `?${params}` : ''}`)
		},
		[router, searchParams, pathname, paramName, value],
	)

	return [isActive, setState] as const
}
